import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import TopSection from '../TopSection';
import DataTable from '../../../components/common/datatable/DataTable';
import { getLTSummaryData } from '../../../redux/actions/LTPlanner/GetLTSummaryDataSlice';
import { postLTSupportTicketEndpoint, postResolveLTSupportTicketEndpoint } from '../../../common/endpoints';
import { LTTicketSummaryTableHeaders } from './TicketSummaryHeader';
import ButtonComponent from '../../../components/common/button/Button';
import { postResolveLTSupportTicket } from '../../../redux/actions/LTPlanner/PostResolveLTTicketSummarySlice';
import { toast } from "react-toastify";
import { Loader } from '../../../components/common/Loader';

const LTTicketSummary = () => {
    const userEmail = localStorage.getItem("data")
    const dispatch = useDispatch();
    const stateSelector = useSelector((state) => state);
    const [rowData, setRowData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const gridRef = useRef();
    const currentPageRef = useRef(0);
    const [gridApi, setGridApi] = useState();

    const pagination = true;
    const paginationPageSize = 10;
    const paginationPageSizeSelector = [10, 20, 30, 50, 100];

    const onGridReady = (params) => {
        setGridApi(params?.api);
        gridRef.current = params?.api;
        setSelectedRows([])
    }

    const onSelectionChanged = (params) => {
        const filteredSelectedRows = [];
        params?.api?.forEachNodeAfterFilter((node) => {
            if (node.isSelected()) {
                filteredSelectedRows.push(node.data);
            }
        });
        setSelectedRows(filteredSelectedRows);
    }

    const rowSelection = useMemo(() => {
        return {
            mode: 'multiRow',
            isRowSelectable: (rowNode) => rowNode?.data?.status !== "RESOLVED",
        }
    })

    const gridOptions = {
        getRowId: (params) => {
            return `${params?.data?.ltUserSupportTicketSeqId}`
        },
        overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
        overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
        defaultColDef: {
            sortable: true,
            filter: 'agMultiColumnFilter',
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            suppressMiniFilter: false,
                        },
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            excelMode: 'windows',
                            suppressMiniFilter: false,
                            buttons: ['apply', 'reset'],
                        },
                    },
                ],
            },
            autoHeight: true,
            cellStyle: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.5,
                display: "flex",
                alignItems: "center",
            },
            valueGetter: (params) => {
                if (!params.data) return "-";

                const field = params.colDef.field;
                const value = params.data[field];

                return value === null || value === undefined || value === "" ? "-" : value;
            },
        },
    }
    const onPaginationChanged = () => {
        if (gridRef.current && !gridRef.current.isDestroyed()) {
            const currentPage = gridRef.current.paginationGetCurrentPage();
            currentPageRef.current = currentPageRef.current || currentPage;
        }
    };
    const onFirstDataRendered = () => {
        if (gridRef.current && !gridRef.current.isDestroyed()) {
            gridRef.current.paginationGoToPage(currentPageRef.current || 0);
        }
    };
    const getRowHeight = (params) => {
        return params.api.getDisplayedRowAtIndex(params.node.rowIndex).rowHeight;
    };


    const getWorkFlowData = async () => {
        try {
            const responseTicketSummary = await dispatch(getLTSummaryData({
                dynamicEndpoint: `${postLTSupportTicketEndpoint}/${userEmail}`,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseTicketSummary?.meta?.requestStatus === 'fulfilled') {
                gridApi?.deselectAll();
                setRowData(responseTicketSummary?.payload);
            } else {
                console.error('Failed to fetch data:', responseTicketSummary?.error);
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    useEffect(() => {
        getWorkFlowData();
    }, [])

    const handleResolveTicket = async () => {
        const selectedSeqArray = [];
        selectedRows?.map(item => {
            selectedSeqArray.push(item?.ltUserSupportTicketSeqId)
        })
        const requestResolveBody = {
            "ltUserSupportTicketSeqId": selectedSeqArray,
            "userEmail": userEmail
        }
        try {
            const responseResolveTicketSummary = await dispatch(postResolveLTSupportTicket({
                dynamicEndpoint: `${postResolveLTSupportTicketEndpoint}`,
                data: requestResolveBody,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            console.log("responseResolveTicketSummary ", responseResolveTicketSummary);
            if (responseResolveTicketSummary?.meta?.requestStatus === 'fulfilled') {
                gridApi?.deselectAll();

                toast.success(responseResolveTicketSummary?.payload, {
                    autoClose: 2000,
                });
                setSelectedRows([]);
                getWorkFlowData()
            } else if (responseResolveTicketSummary?.meta?.requestStatus === "rejected") {
                toast.error(responseResolveTicketSummary?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            } else {
                console.error('Failed to fetch data:', responseResolveTicketSummary?.error);
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    return (
        (stateSelector?.PostResolveLTTicketSummarySlice?.loading || stateSelector?.GetLTSummaryDataSlice?.loading) ?
            <Loader />
            :
            <div>
                <TopSection
                    labelList={[
                        { title: "Home", path: "/landing-page" },
                        { title: "Ticket Summary" },
                    ]}
                    tabTitle="Ticket Summary"
                />
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <div>
                        {rowData && <DataTable
                            height="400px"
                            ref={gridRef}
                            columns={LTTicketSummaryTableHeaders}
                            rows={rowData || []}
                            paginationProp={pagination}
                            paginationPageSize={paginationPageSize}
                            paginationPageSizeSelector={paginationPageSizeSelector}
                            onGridReady={onGridReady}
                            onSelectionChanged={onSelectionChanged}
                            headerCheckboxSelectionFilterOnly={true}
                            rowSelection={rowSelection}
                            gridOptions={gridOptions}
                            getRowHeight={getRowHeight}
                            onPaginationChanged={onPaginationChanged}
                            onFirstDataRendered={onFirstDataRendered}
                        />}
                    </div>
                </div>
                <div style={{ margin: '20px 0px', display: 'flex', gap: 10, justifyContent: "end", alignItems: 'center' }}>
                    <div>
                        <ButtonComponent
                            maxWidth="200px"
                            label="Resolve"
                            type="secondary"
                            onClick={handleResolveTicket}
                            disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined)}
                        />
                    </div>
                </div>
            </div>
    )
}

export default LTTicketSummary;